"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var classNames = require("classnames");
var core_link_1 = require("./core_link");
var tracker_1 = require("../tracker");
var react_tracking_1 = require("react-tracking");
var bind_1 = require("../bind");
var react_router_1 = require("react-router");
var LEFT_GAP = 'previous_ellipsis';
var RIGHT_GAP = 'next_ellipsis';
var range = function range(from, to) {
    var array = [];
    for (var i = from; i <= to; i += 1) {
        array.push(i);
    }
    return array;
};
var COMPONENT_NAME = 'RQLPagination';
var RQLPagination = /** @class */ (function (_super) {
    tslib_1.__extends(RQLPagination, _super);
    function RQLPagination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RQLPagination.prototype, "currentPage", {
        get: function () {
            var page = Math.ceil(this.props.offset / this.props.limit) + 1;
            if (page < 1) {
                return 1;
            }
            return page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RQLPagination.prototype, "totalPages", {
        get: function () {
            return Math.ceil(this.props.total / this.props.limit);
        },
        enumerable: true,
        configurable: true
    });
    RQLPagination.prototype.validPage = function (page) {
        return page !== this.currentPage;
    };
    Object.defineProperty(RQLPagination.prototype, "middleRange", {
        get: function () {
            var windowFrom = this.currentPage - this.props.paginationWindow;
            var windowTo = this.currentPage + this.props.paginationWindow;
            var totalPages = this.totalPages;
            if (windowTo > totalPages) {
                windowFrom -= windowTo - totalPages;
                windowTo = totalPages;
            }
            if (windowFrom < 1) {
                windowTo += 1 - windowFrom;
            }
            return range(Math.max(1, windowFrom + 1), Math.min(windowTo, totalPages));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RQLPagination.prototype, "leftRange", {
        get: function () {
            if (this.props.paginationWindow < this.middleRange[0]) {
                return [1, LEFT_GAP]; // display first page and gap only
            }
            // display all pages from beginning to middle range
            return range(1, this.middleRange[0] - 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RQLPagination.prototype, "rightRange", {
        get: function () {
            var totalPages = this.totalPages;
            var endOfMiddleRange = this.middleRange[this.middleRange.length - 1];
            if (totalPages > endOfMiddleRange) {
                return [RIGHT_GAP]; // display gap only
            }
            // display all pages from middle range to end
            return range(endOfMiddleRange + 1, totalPages);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RQLPagination.prototype, "pageNumbers", {
        get: function () {
            return this.leftRange.concat(this.middleRange).concat(this.rightRange);
        },
        enumerable: true,
        configurable: true
    });
    RQLPagination.prototype.trackInteraction = function (pageNum) {
        this.props.tracking.trackEvent({
            eventType: tracker_1.CLICK,
            page: pageNum,
            perPage: this.props.limit,
        });
    };
    RQLPagination.prototype.renderEllipsisLink = function (pageNum) {
        var classes = classNames('pagination__page', 'pagination__page--gap', { 'pagination__page--before': pageNum < this.currentPage }, { 'pagination__page--after': pageNum > this.currentPage });
        return (React.createElement("li", { className: classes, key: pageNum },
            React.createElement("a", { rel: "nofollow" })));
    };
    RQLPagination.prototype.renderPageNumberLink = function (pageNum) {
        var _a;
        var _b, _c;
        var classes = classNames('pagination__page', 'pagination__page--number', { 'pagination__page--active': pageNum === this.currentPage }, { 'pagination__page--before': pageNum < this.currentPage }, { 'pagination__page--after': pageNum > this.currentPage });
        return (React.createElement("li", { key: pageNum, className: classes },
            React.createElement(core_link_1.default, { to: {
                    query: tslib_1.__assign(tslib_1.__assign({}, (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.query), (_a = {}, _a[this.props.pageParam] = pageNum, _a)),
                    anchor: this.props.anchor,
                }, trackInteraction: this.trackInteraction, rel: "nofollow", replace: this.props.replaceHistory }, pageNum)));
    };
    RQLPagination.prototype.renderPreviousButton = function () {
        var _a;
        var _b, _c;
        if (this.currentPage === 1) {
            return null;
        }
        var newPage = this.currentPage - 1;
        return (React.createElement("li", { key: "previous", className: "pagination__page pagination__page--previous" },
            React.createElement(core_link_1.default, { to: {
                    query: tslib_1.__assign(tslib_1.__assign({}, (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.query), (_a = {}, _a[this.props.pageParam] = newPage, _a)),
                    anchor: this.props.anchor,
                }, rel: "nofollow", replace: this.props.replaceHistory }, I18n.t('commons.previous'))));
    };
    RQLPagination.prototype.renderNextButton = function () {
        var _a;
        var _b, _c;
        if (this.currentPage === this.totalPages) {
            return null;
        }
        var newPage = this.currentPage + 1;
        return (React.createElement("li", { key: "next", className: "pagination__page pagination__page--next" },
            React.createElement(core_link_1.default, { to: {
                    query: tslib_1.__assign(tslib_1.__assign({}, (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.query), (_a = {}, _a[this.props.pageParam] = newPage, _a)),
                    anchor: this.props.anchor,
                }, replace: this.props.replaceHistory, rel: "nofollow", anchor: this.props.anchor }, I18n.t('commons.next'))));
    };
    RQLPagination.prototype.renderPages = function () {
        var _this = this;
        return this.pageNumbers.map(function (pageNum) {
            if (pageNum === LEFT_GAP || pageNum === RIGHT_GAP) {
                return _this.renderEllipsisLink(pageNum);
            }
            return _this.renderPageNumberLink(pageNum);
        });
    };
    RQLPagination.prototype.render = function () {
        if (this.totalPages <= 1 || (this.props.offset >= this.props.total)) {
            return null;
        }
        return (React.createElement("div", { className: "pagination-container" },
            React.createElement("ul", null,
                this.renderPreviousButton(),
                this.renderPages(),
                this.renderNextButton())));
    };
    RQLPagination.defaultProps = {
        limit: 0,
        offset: 0,
        total: 0,
        paginationWindow: 2,
        pageParam: 'page',
        replaceHistory: false
    };
    tslib_1.__decorate([
        bind_1.default
    ], RQLPagination.prototype, "trackInteraction", null);
    RQLPagination = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME })
    ], RQLPagination);
    return RQLPagination;
}(React.Component));
exports.RQLPagination = RQLPagination;
exports.default = react_router_1.withRouter(RQLPagination);
//# sourceMappingURL=rql_pagination.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/rql_pagination.js
// module id = gcrZ
// module chunks = 0 1 2 3 4 9 10 11 12 13 14 20